import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetSwipeCpvInfoDetailsAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const cpvInfo = createAsyncThunk('get/get-cpv-info', GetSwipeCpvInfoDetailsAPI);

export const CpvInfoSlice = createSlice({
	name: 'cpvInfo',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[cpvInfo.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[cpvInfo.rejected.toString()]: setAPIError,
		[cpvInfo.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;
			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[CpvInfoSlice.name]: ReturnType<typeof CpvInfoSlice.reducer>;
}

export const cpvSelector = (state: IStates): any => {
	return state[CpvInfoSlice.name] || {};
};

export const useCpvInfo = (): any => useSelector(cpvSelector);

export const fetchCpvInfo =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(cpvInfo({}));
		return;
	};

export const resetCpvInfo =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(CpvInfoSlice.actions.RESET());
		return;
	};
